import { render, staticRenderFns } from "./button-list.vue?vue&type=template&id=c0722ae4&scoped=true&"
import script from "./button-list.vue?vue&type=script&lang=js&"
export * from "./button-list.vue?vue&type=script&lang=js&"
import style0 from "./button-list.vue?vue&type=style&index=0&id=c0722ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0722ae4",
  null
  
)

export default component.exports